/** @returns {'image' | 'pdf' | 'text' | null} */
export function documentPreviewKind(doc) {
  const mime = (doc?.mime_type || '').toLowerCase();
  const name = (doc?.original_name || '').toLowerCase();

  if (mime.startsWith('image/')) return 'image';
  if (mime === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  if (
    mime.startsWith('text/') ||
    mime === 'application/json' ||
    /\.(txt|md|markdown|csv|json|log)$/i.test(name)
  ) {
    return 'text';
  }

  return null;
}
